import {Component, Input} from '@angular/core';
import {CustomerCashback} from "../../../models/customer-cashback";
import {Card, CustomerOverviewCardContainer} from "../../../dto/card";
import {CardInfo} from "../../../dto/CardbroGateway/card-info";

@Component({
  selector: 'app-customer-cashback-view',
  templateUrl: './customer-cashback-view.component.html',
  styleUrls: ['./customer-cashback-view.component.css']
})
export class CustomerCashbackViewComponent {

  @Input() cardContainers: CustomerOverviewCardContainer[];
  @Input() cashbacks: CustomerCashback[];

  private cashbackToCardContainerMap = new Map<number, CustomerOverviewCardContainer>();

  getCardContainerForCashback(cashback: CustomerCashback): CustomerOverviewCardContainer {
    if (!this.cashbackToCardContainerMap.has(cashback.id)) {
      let foundCard = this.cardContainers
        .find(cardContainer => cardContainer.card && cardContainer.card.id == cashback.cardId);

      if (foundCard)
        this.cashbackToCardContainerMap.set(cashback.id, foundCard);
    }

    return this.cashbackToCardContainerMap.get(cashback.id);
  }

  getCardForCashback(cashback: CustomerCashback): Card|null {
    return this.getCardContainerForCashback(cashback)?.card;
  };

  getCardInfoForCashback(cashback: CustomerCashback): CardInfo|null {
    return this.getCardContainerForCashback(cashback)?.cardInfo;
  };

  replaceBackslashesWithNewlines(description: string): string {
    return description?.replace(/\\/g, '\n') ?? '';
  }

}
